import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { MasterPassService } from 'src/app/services/master-pass/master-pass.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-validate-version-two',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.scss']
})
export class ValidateComponent implements OnInit {
  pollingCount = 1;
  paymentMethod = 'master_pass';
  paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;
  loading = true;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;
  pollingInterval;

  // Countdown
  config = { leftTime: 45, format: 's' };
  public sessionToken: string;
  public transactionUid: string;
  timeout = 45;
  countdownTimer;
  hidePgLogo = false;
  sessionData: Session;

  constructor() { 
  }

  ngOnInit(): void {
    this.sendPostbackMessage();
  }

  private sendPostbackMessage() {
    window.parent.postMessage({
      status: 'COMPLETED',
      paymethod: 'MASTERPASS'
    }, `${window.location.protocol}//${window.location.host}`);
  }

}
